import { useEffect, useState } from 'react';
import { ProjectResources } from '../../domain/resources/ProjectResources';
import { useRetrieveOrganizationResources } from '../organization/useRetrieveOrganizationResources';
import { useRetrieveActiveProject } from './useRetrieveActiveProject';

type UseRetrieveProjectResourcesResponse = {
  data?: ProjectResources;
};

// Hooks act as 'Adapter' layer.
export const useRetrieveActiveProjectResources = (): UseRetrieveProjectResourcesResponse => {
  const { data: activeProject } = useRetrieveActiveProject();
  const { data: resources } = useRetrieveOrganizationResources();
  const [activeProjectResources, setActiveProjectResources] = useState<ProjectResources | undefined>();

  useEffect(() => {
    if (resources && activeProject) {
      const projectResources = resources.getProjectResources(activeProject.id);
      setActiveProjectResources(projectResources);
    }
  }, [resources, activeProject]);

  return {
    data: activeProjectResources,
  };
};
